// store/modules/chatbot/mutations.js
import Vue from "vue";

export default {
  SET_LOADING(state, v) {
    state.loading = !!v;
  },

  // ✅ Lista GLOBAL de chats
  SET_LIST(state, list) {
    state.list = Array.isArray(list) ? list : [];
  },

  // ✅ Guardar conversaciones de UNA reserva en caché
  SET_RESERVATION_CHATS(state, { reservationId, chats }) {
    const key = `reservation_${reservationId}`;
    Vue.set(state.reservationCache, key, Array.isArray(chats) ? chats : []);
  },

  // ✅ Opcional: limpiar caché de una reserva
  CLEAR_RESERVATION_CHATS(state, reservationId) {
    const key = `reservation_${reservationId}`;
    if (state.reservationCache[key]) {
      Vue.delete(state.reservationCache, key);
    }
  },

  // ✅ Opcional: limpiar TODO el caché de reservas
  CLEAR_ALL_RESERVATION_CHATS(state) {
    state.reservationCache = {};
  },

  // 🔔 marcar leídos (para la lista GLOBAL)
  // 🔔 marcar leídos (para la lista GLOBAL)
  // 🔔 marcar leídos (para la lista GLOBAL)
  MARK_ONE_READ(state, { chat_id, checkin_id }) {
    if (!state.list || !state.list.length) return;

    let it = null;

    if (chat_id) {
      const target = Number(chat_id);
      it = state.list.find(
        (x) =>
          Number(x.chat_id) === target || // caso normal
          Number(x.id || NaN) === target // por si en algún sitio usas id
      );
    }

    // fallback legacy por checkin_id si aún lo usas
    if (!it && checkin_id) {
      it = state.list.find(
        (x) => String(x.checkin_id || "") === String(checkin_id)
      );
    }

    if (it) {
      it.has_new_message = false;
    }
  },

  MARK_ALL_READ(state) {
    state.list = (state.list || []).map((x) => ({
      ...x,
      has_new_message: false,
    }));
  },

  SET_QUESTION(state, question) {
    state.question = question;
  },

  SET_UNSAVED_CHANGES(state, status) {
    state.unsavedChanges = status;
  },

  SET_CHANGES_QUESTION(state, status) {
    state.activeFechQuestion = status;
  },

  SET_ANSWER(state, payload) {
    if (state.question?.id === payload.id) {
      state.question.answer = payload.answer;
    }
  },

  SET_REFRESH_QUESTIONS(state, value) {
    state.refreshQuestions = value;
  },
};
